import { VOMedia } from "../model/DataStructure.js";
import { MediaItem } from "./MediaItem.js";

export class VideoOverlay {
    public element: HTMLDivElement;

    private _mediaItem: MediaItem;

    constructor(private _container: HTMLDivElement) {
        this.element = document.createElement("div");
        this.element.id = "video-overlay";

        this.element.innerHTML = `
            <div class="video-overlay-background"></div>
            <div class="video-overlay-content"></div>
        `;
        this._mediaItem = new MediaItem(
            {
                element: this.element.querySelector(".video-overlay-content"),
                autoplay: true,
                loop: true,
                controls: false
            });

        this.element.addEventListener("click", () => this.close());
    }

    public open(video: VOMedia): void {
        this._container.appendChild(this.element);
        this._mediaItem.load(video);
    }

    public close(): void {
        this.element.remove();
        this._mediaItem.clear();
    }
}